import React from 'react'
import { FormGroup, InputGroup } from '@blueprintjs/core'
import style from './style.scss'

export const TelegramConfigDialog = ({ parent }) => {

    const onInputChange = (event) => {
        // @ts-ignore
        parent.setState({ messaging: { channels: { telegram: { ...parent?.state?.messaging?.channels?.telegram, [event.target.name]: event.target.value, enabled: parent.state.isTelegramEnabled } } } })
    }

    const formGroupStyle = {
        marginBottom: 0
    }

    return (
        <>
            <div>
                <div className={style.stepSubTitle}>Enter the configuration details for Telegram.</div>
                <p style={{ fontSize: '14px', color: '#838383' }}>Ensure all fields are completed for successful setup.</p>
            </div>
            <div style={{ maxWidth: '100%', height: 'auto', overflowY: 'auto' }} >
                <div className={style.formWrapper}>
                    <div style={{ display: 'grid', gridTemplateColumns: '49% 49%', justifyContent: 'space-between' }}>
                        <FormGroup style={formGroupStyle} label="Bot Token" labelFor="botToken" helperText="Enter the bot token generated for your Telegram application.">
                            <InputGroup
                                id="botToken"
                                placeholder="Enter Access Token here"
                                name="botToken"
                                value={parent?.state?.messaging?.channels?.telegram?.botToken}
                                onChange={onInputChange}
                            />
                        </FormGroup>
                    </div>
                </div>
            </div>
        </>
    )
}
